import { getAlertMessageFunction } from '../../../common/Util';

export const isValidate = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();

  for (const data of dataList) {
    const { htm006, htm007, htm001, htm002, htm016 } = data;

    //국세청 선택유무
    const isNationalTax = htm006 === '1' || htm006 === '6' || htm006 === '9';

    //의료증빙코드를 선택해주세요.
    if (htm006 === '') {
      alertMessage(t('alertMessage.message1'));
      return false;
    }
    //건수를 입력해주세요.
    if (htm007 < 1) {
      alertMessage(t('alertMessage.message2'));
      return false;
    }

    //국세청 자료를 제외한 자료는 지급처, 사업자번호를 입력하셔야 합니다.
    if (!isNationalTax && (htm001 === '' || htm002 === '')) {
      alertMessage(t('alertMessage.message3'));
      return false;
    }

    //사업자번호 자릿수를 확인해주세요.
    if (!isNationalTax && htm002.replace(/[^0-9]/g, '').length != 10) {
      alertMessage(t('alertMessage.message6'));
      return false;
    }

    //안경점은 인당 한도금액은 50만원 입니다.
    if (htm006 == '7' && htm016 > 500000) {
      alertMessage(t('alertMessage.message5'));
      return false;
    }

    //금액을 입력해주세요.
    if (htm016 < 1) {
      alertMessage(t('alertMessage.message4'));
      return false;
    }
  }

  return true;
};
